import { Injectable, inject } from '@angular/core';
import { select, Store } from '@ngrx/store';

import { SuppressToastrType } from '../models/suppress-toastr';

import { Device } from '@app/store/device.model';
import * as fromRoot from '@app/store/index';
import { createPlantModelParametersByDeviceSerialNumberSelector } from '@app/store/index';
import {
  setPlantModelParameterValuesRequest,
  updatePlantModelParameter,
} from '@app/store/plant-model-parameter.actions';
import { PlantModelParameter } from '@app/store/plant-model-parameter.model';

@Injectable({
  providedIn: 'root',
})
export class PlantModelParameterService {
  private store$ = inject<Store<fromRoot.AppState>>(Store);

  plantModelParameterEntities$ = this.store$.pipe(select(fromRoot.selectPlantModelParameterEntities));

  requestSetPlantModelParameterValues(
    plantModelParameterValues: { [key: string]: any },
    timeout = 5000,
    suppressToastr: SuppressToastrType = { begin: true, success: true },
  ) {
    this.store$.dispatch(setPlantModelParameterValuesRequest({ plantModelParameterValues, timeout, suppressToastr }));
  }

  selectDevicePlantModelParameters(device: Device) {
    return this.store$.select(createPlantModelParametersByDeviceSerialNumberSelector(device.serialNumber));
  }

  selectDevicePlantModelParametersForSetup(device: Device, filterActive = true) {
    return this.store$.select(
      fromRoot.createPlantModelParametersForSetupByDeviceSerialNumberSelector(device.serialNumber, filterActive),
    );
  }

  updatePlantModelParameter(plantModelParameter: Partial<PlantModelParameter> | string, changes: { unit: string }) {
    const id = typeof plantModelParameter === 'string' ? plantModelParameter : plantModelParameter.id;
    const update = { id, changes };
    this.store$.dispatch(updatePlantModelParameter({ update }));
  }
}
